import { MandatoryWaypointsNoRestrictions } from "./MandatoryWaypointsNoRestrictions.js";
export { MandatoryWaypointState, cloneMandatoryWaypointStateMap };
function cloneMandatoryWaypointStateMap(map) {
    return new Map([...map.entries()].map(([id, state]) => [id, state.clone()]));
}
class MandatoryWaypointState {
    constructor({ mandatoryWaypoints }) {
        this.mandatoryWaypoints = mandatoryWaypoints;
    }
    next() {
        if (this.isFinished()) {
            return undefined;
        }
        else {
            return this.mandatoryWaypoints.next();
        }
    }
    isAllowed(waypoint) {
        return this.mandatoryWaypoints.isAllowed(waypoint);
    }
    moveNext(waypoint) {
        this.mandatoryWaypoints.moveNext(waypoint);
    }
    isFinished() {
        return this.mandatoryWaypoints.isFinished();
    }
    clone() {
        return new MandatoryWaypointState({
            mandatoryWaypoints: this.mandatoryWaypoints.clone()
        });
    }
    static none() {
        return new MandatoryWaypointState({ mandatoryWaypoints: new MandatoryWaypointsNoRestrictions() });
    }
}
//# sourceMappingURL=MandatoryWaypointState.js.map